import { render, staticRenderFns } from "./TechniqueDPage.vue?vue&type=template&id=2dd81152&"
import script from "./TechniqueDPage.vue?vue&type=script&lang=js&"
export * from "./TechniqueDPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports